import * as React from 'react';

import IconStep1 from '@/assets/icons/icon_step_1.svg';
import IconStep2 from '@/assets/icons/icon_step_2.svg';
import IconStep3 from '@/assets/icons/icon_step_3.svg';
import IconStep4 from '@/assets/icons/icon_step_4.svg';
import Image from '@/components/elements/Image';
import { GuidePageTitles } from '@/pages/Guide/types';
import { GuidePaths } from '@/routes/Guide';

import {
  Container,
  ContentBox,
  Flow,
  FlowStepIcon,
  Text,
  TextLarge,
  TextLink,
  TextNote,
  Title,
  TitleSmall,
} from '../style';

const data = [
  {
    title: '利用登録',
    text: '基本情報の入力と本人確認で登録完了！',
    icon: IconStep1,
  },
  {
    title: '入金',
    text: '投票に必要な電子マネー「toreta+（トレタプラス）」をチャージ。「入金/払戻金残高」へ入金し投票することも可能です。',
    linkText: 'toreta+ について',
    linkUrl: `/guide/${GuidePaths.Toreta}`,
    icon: IconStep2,
  },
  {
    title: '投票',
    text: '競輪投票もしくはチャリロト・Dokanto!を購入してみましょう。競輪投票ではフォーメーション・BOX・流し・オッズなど充実した投票方法をご用意しています。',
    icon: IconStep3,
  },
  {
    title: '精算',
    text: '的中すると払戻金は「入金/払戻金残高」へ自動的に入金されます。「入金/払戻金残高」はtoreta+ へチャージもしくは銀行振込への精算が可能です。',
    icon: IconStep4,
  },
];

const GuideFlowTemplate: React.FC = () => {
  return (
    <Container>
      <ContentBox>
        <Title>{GuidePageTitles.Flow}</Title>
        <TextLarge>
          スマートフォンやパソコンでカンタン登録！ toreta+
          をチャージしたらすぐに投票が可能です。
        </TextLarge>
        <TextNote>
          <i>※</i>DMM競輪の利用登録を行うにはDMM会員登録（無料）が必要です。
        </TextNote>
        <Flow>
          {data.map((item, i) => (
            <li key={i}>
              <FlowStepIcon>
                <Image
                  srcSet={item.icon}
                  alt={`step${i + 1}`}
                  width="48px"
                  height="54px"
                />
              </FlowStepIcon>
              <TitleSmall textAlign="left">{item.title}</TitleSmall>
              <Text>
                {item.text}
                {item.linkUrl && (
                  <>
                    <br />
                    <TextLink to={item.linkUrl}>{item.linkText}</TextLink>
                  </>
                )}
              </Text>
            </li>
          ))}
        </Flow>
      </ContentBox>
    </Container>
  );
};

export default GuideFlowTemplate;
